import {Directive, OnInit} from '@angular/core';
import {TableColumnComponent} from 'src/ag-grid-wrapper/column/column.component';
import {WholeNumberEditorComponent} from './whole-number-editor.component';
import { get, isNil } from 'lodash';

@Directive({
  selector: 'ui-table-column[wholeNumber]',
})
export class WholeNumberDirective implements OnInit {
  
  constructor(public tableColumn: TableColumnComponent) {
  }

  ngOnInit(): void {
    if (this.tableColumn.type !== 'number' && this.tableColumn.type !== 'numberStr') {
      this.tableColumn.type = 'number';
    }
    this.tableColumn.customEditor = WholeNumberEditorComponent;
    this.tableColumn.valueGetter = (params: any): string => {
      let val: any;
      if (params && params.data) {
        val = get<string>(params.data, params.colDef.field);
      } else if (params && !isNil(params.value)) {
        val = params.value;
      }
      return val;
    };
  }
}
